import React, { useEffect, useState, useRef } from "react";
import style from "../../css/homepage/Navbar.module.css";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../Theme_toggle";

const Navbar = () => {
  
  const [scrolling, setScrolling] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const navbarRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsNavbarOpen(false);
      }
    };

    if (isNavbarOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isNavbarOpen]);



  return (
    <nav
      className={`navbar navbar-expand-lg ${style.navbar__container} ${scrolling ? style.scrolled : ""}`}
      ref={navbarRef}
    >
      <div className="container">
        <a className="navbar-brand" href="/">
          <div className={style.header__logo}>

            <h1 className={style.header__title}>
              <span className={style.header__light}>SWING</span><span className={style.header__light}></span>ALGO
            </h1>
          </div>
        </a>
        <button
          className={`navbar-toggler ${style.togglebutton_nav}`}
          type="button"
          onClick={() => setIsNavbarOpen(!isNavbarOpen)}
          aria-expanded={isNavbarOpen}
        >
         <i className="fa-solid fa-bars"   style={{ color: 'var(--gold)'  }} ></i> 
        </button>
        <div className={`collapse navbar-collapse ${style.collapse_list} ${isNavbarOpen ? "show" : ""}`} id="navbarSupportedContent">
          <ul className={`navbar-nav ms-auto mb-2 mb-lg-0 ${style.nav__link}`}>
             <ThemeToggle/>
            <li className="nav-item">
              <Link to="/" className={`nav-link ${location.pathname === "/" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
                Home
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link to="story_success" className={`nav-link ${location.pathname === "/story_success" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
                Success stories
              </Link>
            </li> */}
            <li className="nav-item">
              <Link to="blog" className={`nav-link ${location.pathname === "/blog" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
                Blogs
              </Link>
            </li>
            <li className="nav-item">
              <Link to="news" className={`nav-link ${location.pathname === "/news" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
            News
              </Link>
            </li>
            
            {/* <li className="nav-item">
              <Link to="about_us" className={`nav-link ${location.pathname === "/about_us" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
                About us
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link to="contact_us" className={`nav-link ${location.pathname === "/contact_us" ? style.active : ""}`} onClick={() => setIsNavbarOpen(false)}>
                Contact us
              </Link>
            </li> */}
          </ul>
          <div className={style.signin_btn_div}>
            <a data-bs-toggle="modal" data-bs-target="#Login_otp_modal">   
            <button className={style.signin_btn}> <i className={`fa-solid fa-right-to-bracket ${style.signin_icon}`}></i> Log In  </button>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
